<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (loading) {
<div class="pdf-loading-container">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (noDataAvail) {
<span class="no-data-message">
    No Data Available
  </span>
}

  @if (formNotAvail) {
<span class="error-message">
    Error loading the requested form!
  </span>
}

  @if (formLoaded && !noDataAvail && pdfContent) {
<iframe
   
    [src]="pdfContent"
    style="width: 100%; height: 80vh; border: none;">
  </iframe>
}
</div>
